import script from "./user_home.vue?vue&type=script&setup=true&lang=ts"
export * from "./user_home.vue?vue&type=script&setup=true&lang=ts"

import "./user_home.vue?vue&type=style&index=0&id=2c75b82a&lang=css"

const __exports__ = script;

export default __exports__